/**
 * Обёртка над localStorage для Discord Activities
 * В iframe Discord может блокировать localStorage, используем fallback на memory
 */

const memoryStorage: Record<string, string> = {};

function isLocalStorageAvailable(): boolean {
  try {
    const test = '__storage_test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch {
    return false;
  }
}

const useLocalStorage = isLocalStorageAvailable();

export const storage = {
  getItem(key: string): string | null {
    if (useLocalStorage) {
      return localStorage.getItem(key);
    }
    return memoryStorage[key] ?? null;
  },

  setItem(key: string, value: string): void {
    if (useLocalStorage) {
      localStorage.setItem(key, value);
    } else {
      memoryStorage[key] = value;
    }
  },

  removeItem(key: string): void {
    if (useLocalStorage) {
      localStorage.removeItem(key);
    } else {
      delete memoryStorage[key];
    }
  },
};
